import React from 'react';

import { useTranslation } from '../../../../../hooks';

interface RewardsTimerDigitProps {
  label: string;
  value: string;
  hideDots?: boolean;
}

export const RewardsTimerDigit: React.FC<RewardsTimerDigitProps> = ({ value, label, hideDots = false }) => {

  const t = useTranslation();

  return (
    <>
      <p className="rewards-time-box">
        <span className="rewards-time-num">{value}</span>
        <span>{t(label)}</span>
      </p >
      {!hideDots && <span className="rewards-time-dot">:</span>}
    </>
  );
};
